export default class AnuncioInput {
    constructor () {
      this.id = null
      this.titulo = null
      this.link = null
      this.cor_fundo = null
      this.ativa = 'S'
      this.imagem = []
    }
  }
